
<template>
  <div class="apply_box">
    <div class="succ_bg"></div>
    <p class="title">订单提交成功</p>
    <p class="info">注意！初审通过后可能还需要绑卡哦</p>
    <p class="btn"
       @click="toPageUrl">查看订单进度</p>
    <!-- <div class="header"
         v-else>
      <div class="fail_bg"></div>
      <p class="title">抱歉您的资质不符合产品的申请条件</p>
    </div> -->
    <!-- <div class="bg"></div>
    <LoanList :orderList="orderList"
              :orderTitleJson="orderTitleJson" /> -->
  </div>
</template>

<script>
import LoanList from '@/components/loanList';
export default {
  components: {
    LoanList,
  },
  data () {
    return {
      status: '',//失败成功的标志
      orderId: '',
      orderList: [],
      orderTitleJson: {},
    }
  },
  mounted () {
    this.status = this.$route.query.status;
    this.orderId = this.$route.query.orderId;
    if (this.status == '1') {
      this.util.title('申请成功');
    } else {
      this.util.title('申请失败');
    }
    // if (window.history && window.history.pushState) {
    //   history.pushState(null, null, document.URL);
    //   window.addEventListener('popstate', this.goBack, false);
    // }
    // this.getDetails();
  },
  // destroyed () {
  //   window.removeEventListener('popstate', this.goBack, false);
  // },
  methods: {
    toPageUrl () {
      // window.location.href = '/loan/applyDetail?orderId=' + this.orderId;
      this.$router.push({
        path: '/loan/applyDetail',
        query: {
          orderId: this.orderId,
          webRefresh: '1'
        }
      });
    },
    // goBack () {
    //   // 去返回
    //   this.goHome();//回到首页
    // },
    // //跳转客户端
    // goHome () {
    //   let json = {
    //   }
    //   try {
    //     window.webkit.messageHandlers.goHome.postMessage(json);//ios
    //   } catch (err) {
    //     window.AppJs.goHome();//android
    //   }
    // },
    getDetails () {
      let param = {
        orderId: this.orderId
      }
      let _this = this;
      this.$get('/app/api/v1/order/details', param)
        .then(res => {
          var e = res;
          if (e.code == 200) {
            e.data.appOrderCells.map(function (item) {
              if (item.type == "product") {
                _this.orderList = item.content//产品列表
                _this.orderTitleJson = item.head;
              }
            })
          }
          else {
            _this.util.toast({ msg: e.msg })
          }
        })
        .catch(error => { });
    },
  }

}
</script>
<style scoped>
.apply_box {
  background: #ffffff;
  padding: 0.2rem 0 0.33rem 0;
  text-align: center;
}
.bg {
  background: #f7f7f7;
  width: 100%;
  height: 0.1rem;
}
/* .header {
  padding: 0.2rem 0 0.33rem 0;
  background: #ffffff;
} */
.succ_bg,
.fail_bg {
  width: 1.09rem;
  height: 0.9rem;
  background: url('../../assets/img/afterLoan/success_bg.png') no-repeat top
    center;
  background-size: 100% 100%;
  margin: 0 auto;
}
.fail_bg {
  background: url('../../assets/img/afterLoan/apply_fail.png') no-repeat top
    center;
  background-size: 100% 100%;
}
.title {
  color: #333;
  font-size: 0.16rem;
  text-align: center;
  margin-bottom: 0.12rem;
}
.info {
  font-size: 0.12rem;
  color: #ff514a;
  text-align: center;
}
.btn {
  width: 2.45rem;
  background: linear-gradient(
    132deg,
    rgba(89, 163, 252, 1) 0%,
    rgba(60, 100, 246, 1) 100%
  );
  box-shadow: 0px 6px 10px 0px rgba(228, 238, 250, 1);
  border-radius: 25px;
  text-align: center;
  font-size: 17px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  padding: 0.13rem 0;
  margin: 0 auto;
  margin-top: 0.4rem;
}
</style>
